export default __webpack_public_path__ + "static/media/upwork.a3571e5c.webp";